import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWarningAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 8.5C12.4142 8.5 12.75 8.83579 12.75 9.25V13.25C12.75 13.6642 12.4142 14 12 14C11.5858 14 11.25 13.6642 11.25 13.25V9.25C11.25 8.83579 11.5858 8.5 12 8.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 16.25C13 16.8023 12.5523 17.25 12 17.25C11.4477 17.25 11 16.8023 11 16.25C11 15.6977 11.4477 15.25 12 15.25C12.5523 15.25 13 15.6977 13 16.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.4542 16.8271L14.1739 4.33594C13.2611 2.55469 10.7338 2.55469 9.82096 4.33593L2.54063 16.8271C2.53269 16.8408 2.52518 16.8546 2.51811 16.8687C1.7037 18.4936 2.8436 20.5 4.70602 20.5L19.2888 20.5C21.1413 20.5 22.3104 18.5143 21.4753 16.8659C21.4686 16.8528 21.4616 16.8398 21.4542 16.8271ZM14.1739 4.33594L14.1856 4.35903L13.5148 4.69461L14.1628 4.31694L14.1739 4.33594ZM12.8441 5.03018C12.4904 4.32327 11.5044 4.32327 11.1507 5.03018C11.1436 5.04445 11.136 5.05848 11.128 5.07227L3.85004 17.5594C3.52526 18.239 4.0284 19 4.70602 19L19.2888 19C19.9767 19 20.4767 18.2434 20.1457 17.561L12.8669 5.07227C12.8588 5.05848 12.8512 5.04445 12.8441 5.03018Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconWarningAlt as ReactComponent };
